import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, loginWithToken, user } = useAuth();
  const location = useLocation();

  const hasLocalAuth = Boolean(
    localStorage.getItem('employer_user') ||
    localStorage.getItem('employer_token') ||
    localStorage.getItem('staff_token') ||
    localStorage.getItem('token')
  );

  React.useEffect(() => {
    if (!user && loginWithToken) {
      try {
        const saved = localStorage.getItem('employer_user') || localStorage.getItem('portal_user');
        if (saved) {
          loginWithToken(JSON.parse(saved));
        }
      } catch (e) {}
    }
  }, [user, loginWithToken]);

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  if (!isAuthenticated && !hasLocalAuth) {
    // Redirect unauthenticated employer/staff access to staff login portal
    return <Navigate to="/staff/login" state={{ from: location, mode: 'login' }} replace />;
  }

  return children;
};

export default ProtectedRoute;
